define(
    'viewmodels/download',[
        "viewmodels/ViewModel",
        "i19n!i19n/strings",
        "services/config",
        "plugins/router",
        "providers/dataprovider",
    ],
    function (ViewModel, i19n, config, router, dataProvider) {

        var vm = new ViewModel(
        {
            i19n: i19n,
            id: '',
            filename: ko.observable(),
            isValid: ko.observable(true),
            canDownload: ko.observable(false),
            isBusy: ko.observable(false)
        });

        vm.activate = function (id) {            
            vm.id = id;
            vm.filename("");

            dataProvider
            .documents
            .actions.canDownload([{ docIdVersionId: vm.id }])
            .done(function (data) {                                
                vm.canDownload(data.success);

                if (vm.canDownload()) {
                    vm.isValid(true);
                    vm.isBusy(true);

                    dataProvider.documents
                    .getDocumentPreview(vm.id)
                    .done(function (result) {
                        var iframe = document.getElementById('preview-iframe');
                        if (!iframe)
                            return;
                        var w = iframe.contentWindow || iframe.contentDocument;

                        if (w && w.document) {
                            var doc = w.document;

                            doc.open();
                            doc.clear();

                            //ALSO IN DOWNLOAD PREVIEW
                            try {
                                if (result.encoding.indexOf('text/html') != -1) {
                                    doc.write(decodeURI(result.data));

                                    var span = doc.getElementsByClassName('auto-style1');
                                    if (span.length) span[0].style.width = "auto";
                                }
                                else if (result.encoding.indexOf('text/plain') != -1) {
                                    doc.write(decodeURI(result.data));
                                }
                                else if (result.encoding.indexOf('image/') != -1) {
                                    doc.write('<img src="' + String.format("{0}{1}", result.encoding, result.data) + '"></img>');
                                }
                                else {
                                    doc.write('unidentified encoding');
                                    console.warn('unidentified encoding : ' + result.encoding);
                                }
                            }
                            catch (e) {
                                console.warn(e);
                            }

                            doc.close();
                        }

                        vm.isBusy(false);                        
                    })
                    .fail(function (e) {
                        vm.isBusy(false);
                        console.warn(e);
                    });

                    dataProvider
                    .documents
                    .getDocumentDetailsWindows(vm.id)
                    .done(function (data) {
                        vm.filename(data.title + " (" + data.docIdVersion + ")" + "." + data.extension);
                    })
                    .fail(function (e) {
                        console.warn(e);
                    });
                } else {
                    vm.isValid(false);
                }
            })
            .fail(function (e) {
                vm.isValid(false);
                vm.isBusy(false);
                console.warn(e);
            });            
        };
        vm.attached = function () {
            
        };
        vm.explore = function () {
            router.navigate("explorer");
        };
        vm.clickHelp = function () {
            window.open('http://help.fileplan.com');
        };
        vm.clickDownload = function (data) {
            window.location = getUrl("documents/instancecontent/" + config.instanceCode + "/", vm.id);

            return false;
        };

        return vm;

        function getUrl(action, id) {
            return config.webApiUrl + action + id;
        }
    }
);
